var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/clipboard-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1541 2.61635H8.84578C7.89245 2.61635 7.11328 3.38635 7.11328 4.33969V5.20135C7.11328 6.15469 7.88328 6.92469 8.83661 6.92469H13.1541C14.1074 6.92469 14.8774 6.15469 14.8774 5.20135V4.33969C14.8866 3.38635 14.1074 2.61635 13.1541 2.61635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.8031 5.20135C15.8031 6.65885 14.6115 7.85052 13.154 7.85052H8.84562C7.38812 7.85052 6.19646 6.65885 6.19646 5.20135C6.19646 4.68802 5.64646 4.36719 5.18812 4.60552C3.89562 5.29302 3.01562 6.65885 3.01562 8.22635V16.8522C3.01562 19.1072 4.85813 20.9497 7.11313 20.9497H14.8865C17.1415 20.9497 18.984 19.1072 18.984 16.8522V8.22635C18.984 6.65885 18.104 5.29302 16.8115 4.60552C16.3531 4.36719 15.8031 4.68802 15.8031 5.20135ZM11.3481 16.3205H7.33313C6.95729 16.3205 6.64563 16.0089 6.64563 15.633C6.64563 15.2572 6.95729 14.9455 7.33313 14.9455H11.3481C11.724 14.9455 12.0356 15.2572 12.0356 15.633C12.0356 16.0089 11.724 16.3205 11.3481 16.3205ZM13.7498 12.6539H7.33313C6.95729 12.6539 6.64563 12.3422 6.64563 11.9664C6.64563 11.5905 6.95729 11.2789 7.33313 11.2789H13.7498C14.1256 11.2789 14.4373 11.5905 14.4373 11.9664C14.4373 12.3422 14.1256 12.6539 13.7498 12.6539Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.4fd34f90dee09edd0551ab19f8b2fff2.svg";
export { ForwardRef as ReactComponent };